var map = {
	"./arrow.png": 6952,
	"./bath.png": 3184,
	"./bed.png": 3710,
	"./blue-check.png": 1460,
	"./caution.png": 8488,
	"./check.png": 7523,
	"./checkmark.png": 2520,
	"./close.png": 8175,
	"./cross.png": 9011,
	"./email.png": 8371,
	"./interac.png": 9513,
	"./lock.png": 7270,
	"./mastercard.png": 1039,
	"./message.png": 9102,
	"./minus.png": 6115,
	"./next.png": 3488,
	"./plus.png": 5931,
	"./prev.png": 5092,
	"./search.png": 1983,
	"./size.png": 9232,
	"./telephone.png": 887,
	"./user.png": 6274,
	"./visa.png": 4820,
	"./xmark.png": 464
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6035;